// fetch company features
export const getCompanyFeaturesInit = 'GET_COMPANY_FEATURES_INIT';
export const getCompanyFeaturesSuccess = 'GET_COMPANY_FEATURES_SUCCESS';
export const getCompanyFeaturesError = 'GET_COMPANY_FEATURES_ERROR';
